var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCrowdvotingFoerdersummenVisualisierungInlineXsRgb = function SvgCrowdvotingFoerdersummenVisualisierungInlineXsRgb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 330,
    height: 280,
    viewBox: "0 0 330 280",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M77.8,50.5h-4.2v-16.1l-4.4,2.2v-4.2l4.8-2.6h3.7v20.6Z",
    style: {
      fill: "#fac328"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1,50.8c-.7,0-1.3-.3-1.8-.8-.5-.5-.7-1.1-.7-1.8s.2-1.3.7-1.8,1.1-.7,1.8-.7,1.3.2,1.8.7c.5.5.8,1.1.8,1.8s-.3,1.3-.8,1.8-1.1.8-1.8.8Z",
    style: {
      fill: "#fac328"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2,50.9c-1.8,0-3.4-.5-4.8-1.5-1.3-1-2.4-2.3-3-3.9-.7-1.6-1-3.4-1-5.3s.3-3.7,1-5.2c.7-1.6,1.8-3,3.1-4,1.4-1,3-1.5,4.8-1.5,2.7,0,4.9,1.1,6.5,3.2,1.6,2.1,2.4,4.6,2.4,7.6s-.8,5.5-2.4,7.6c-1.6,2.1-3.7,3.2-6.5,3.2ZM93.8,45c.9,1.3,2,1.9,3.4,1.9s2.5-.6,3.4-1.9c.8-1.3,1.3-2.9,1.3-4.8s-.4-3.5-1.3-4.8c-.8-1.3-1.9-2-3.4-2s-2.5.7-3.4,2c-.8,1.3-1.3,2.9-1.3,4.8s.4,3.5,1.3,4.8Z",
    style: {
      fill: "#fac328"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.9,50.9c-1.8,0-3.4-.5-4.8-1.5-1.3-1-2.4-2.3-3-3.9-.7-1.6-1-3.4-1-5.3s.3-3.7,1-5.2c.7-1.6,1.8-3,3.1-4,1.4-1,3-1.5,4.8-1.5,2.7,0,4.9,1.1,6.5,3.2,1.6,2.1,2.4,4.6,2.4,7.6s-.8,5.5-2.4,7.6c-1.6,2.1-3.7,3.2-6.5,3.2ZM114.6,45c.9,1.3,2,1.9,3.4,1.9s2.5-.6,3.4-1.9c.8-1.3,1.3-2.9,1.3-4.8s-.4-3.5-1.3-4.8c-.8-1.3-1.9-2-3.4-2s-2.5.7-3.4,2c-.8,1.3-1.3,2.9-1.3,4.8s.4,3.5,1.3,4.8Z",
    style: {
      fill: "#fac328"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.7,50.9c-1.8,0-3.4-.5-4.8-1.5-1.3-1-2.4-2.3-3-3.9-.7-1.6-1-3.4-1-5.3s.3-3.7,1-5.2c.7-1.6,1.8-3,3.1-4,1.4-1,3-1.5,4.8-1.5,2.7,0,4.9,1.1,6.5,3.2,1.6,2.1,2.4,4.6,2.4,7.6s-.8,5.5-2.4,7.6c-1.6,2.1-3.7,3.2-6.5,3.2ZM135.3,45c.9,1.3,2,1.9,3.4,1.9s2.5-.6,3.4-1.9c.8-1.3,1.3-2.9,1.3-4.8s-.4-3.5-1.3-4.8c-.8-1.3-1.9-2-3.4-2s-2.5.7-3.4,2c-.8,1.3-1.3,2.9-1.3,4.8s.4,3.5,1.3,4.8Z",
    style: {
      fill: "#fac328"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M154,33.4v-3.6h16.5v3.6h-6.2v16h-4v-16h-6.2Z",
    style: {
      fill: "#fac328"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.8,35.4v14h-4v-1.7c-1.3,1.4-2.8,2-4.7,2s-2.9-.5-3.8-1.5c-.9-1-1.3-2.4-1.3-4.3v-8.6h4v7.8c0,1,.2,1.8.7,2.2.5.5,1.1.7,1.9.7s1.2-.2,1.8-.5,1.1-.8,1.4-1.3v-8.9h4ZM174.8,33.4c-.6,0-1-.2-1.5-.6-.4-.4-.6-.9-.6-1.5s.2-1,.6-1.4c.4-.4.9-.6,1.5-.6s1.1.2,1.5.6c.4.4.6.9.6,1.5s-.2,1.1-.6,1.5c-.4.4-.9.6-1.5.6ZM182.5,32.9c-.4.4-.9.6-1.5.6s-1.1-.2-1.5-.6c-.4-.4-.6-.9-.6-1.5s.2-1.1.6-1.5c.4-.4.9-.6,1.5-.6s1.1.2,1.5.6c.4.4.6.9.6,1.5s-.2,1.1-.6,1.5Z",
    style: {
      fill: "#fac328"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,45.1v-6.3h-2.8v-3.3h2.8v-3.8h4v3.8h4v3.3h-4v5.6c0,.7.1,1.2.4,1.5.3.3.8.5,1.5.5s1.4-.2,2-.5v3.3c-.8.5-1.9.8-3.3.8-3,0-4.6-1.6-4.6-4.7Z",
    style: {
      fill: "#fac328"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.7,49.8c-2.1,0-3.9-.7-5.4-2-1.5-1.4-2.2-3.2-2.2-5.4s.7-4,2.2-5.3c1.5-1.3,3.3-2,5.4-2s2.9.3,4.2.9v3.4c-1.2-.6-2.4-.8-3.6-.8s-2.3.4-3.1,1.1c-.8.7-1.2,1.6-1.2,2.8s.4,2.1,1.3,2.8c.8.7,1.9,1.1,3.1,1.1s2.7-.3,3.8-1v3.4c-1.3.7-2.8,1-4.4,1Z",
    style: {
      fill: "#fac328"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.5,40.5v8.9h-4v-19.6h4v7.4c1.3-1.4,2.8-2.1,4.7-2.1s2.9.5,3.8,1.5,1.3,2.4,1.3,4.3v8.6h-4v-7.8c0-1-.2-1.8-.7-2.2-.5-.5-1.1-.7-1.9-.7s-1.2.2-1.8.5-1.1.8-1.4,1.3Z",
    style: {
      fill: "#fac328"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.7,49.8c-2.2,0-4-.7-5.5-2-1.5-1.3-2.2-3.1-2.2-5.4s.7-3.8,2-5.2c1.3-1.4,3.1-2.1,5.3-2.1s3.6.7,4.9,2.2c1.2,1.4,1.8,3.2,1.8,5.2v1h-10c.2.9.7,1.7,1.6,2.2.8.5,1.9.8,3.1.8s3-.4,4.5-1.2v3.2c-1.3,1-3,1.4-5.3,1.4ZM235.9,41h6.1c0-.8-.3-1.5-.9-2-.5-.5-1.2-.8-2.1-.8s-1.6.3-2.2.8c-.6.5-.9,1.2-1,2Z",
    style: {
      fill: "#fac328"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.9,40.5v8.9h-4v-14h4v1.7c1.3-1.4,2.8-2,4.7-2s2.9.5,3.8,1.5,1.3,2.4,1.3,4.3v8.6h-4v-7.8c0-1-.2-1.8-.7-2.2-.5-.5-1.1-.7-1.9-.7s-1.2.2-1.8.5-1.1.8-1.4,1.3Z",
    style: {
      fill: "#fac328"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72,79.7c-3,0-5.5-1-7.5-2.9-2-1.9-3-4.4-3-7.4s1-5.4,3-7.4c2-1.9,4.5-2.9,7.6-2.9s4.2.5,5.9,1.5v4c-1.8-1.1-3.7-1.7-5.6-1.7s-3.6.6-4.9,1.8c-1.3,1.2-1.9,2.8-1.9,4.7s.6,3.5,1.8,4.7c1.2,1.2,2.7,1.7,4.5,1.7s3-.4,4-1.3v-6.8h4v8.7c-.8.9-2,1.6-3.4,2.2-1.5.6-3,.9-4.6.9Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,74.2v-8.9h4v14h-4v-1.7c-1.3,1.4-2.8,2-4.7,2s-2.9-.5-3.8-1.5c-.9-1-1.3-2.4-1.3-4.3v-8.6h4v7.8c0,1,.2,1.8.7,2.2.5.5,1.1.7,1.9.7s1.2-.2,1.8-.5,1.1-.8,1.4-1.3Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.4,78.7h-4v-14h4v1.7c1-1.4,2.5-2.1,4.3-2.1s1.9.2,2.7.7c.8.4,1.3,1,1.6,1.7.5-.7,1.1-1.3,2-1.7.9-.4,1.8-.7,2.8-.7,1.5,0,2.8.5,3.6,1.5s1.3,2.4,1.3,4.2v8.8h-4v-7.9c0-1.9-.8-2.9-2.3-2.9s-1.2.2-1.7.5-.9.8-1.2,1.4v8.8h-4v-7.9c0-1.9-.8-2.9-2.3-2.9s-1.1.2-1.7.5c-.6.4-1,.8-1.3,1.3v8.9Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.7,78.9h-4v-14h4v1.7c1-1.4,2.5-2.1,4.3-2.1s1.9.2,2.7.7c.8.4,1.3,1,1.6,1.7.5-.7,1.1-1.3,2-1.7.9-.4,1.8-.7,2.8-.7,1.5,0,2.8.5,3.6,1.5s1.3,2.4,1.3,4.2v8.8h-4v-7.9c0-1.9-.8-2.9-2.3-2.9s-1.2.2-1.7.5-.9.8-1.2,1.4v8.8h-4v-7.9c0-1.9-.8-2.9-2.3-2.9s-1.1.2-1.7.5c-.6.4-1,.8-1.3,1.3v8.9Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.6,61.6c0-.7.2-1.2.7-1.7.5-.5,1-.7,1.7-.7s1.2.2,1.7.7c.5.5.7,1,.7,1.7s-.2,1.2-.7,1.7-1,.7-1.7.7-1.2-.2-1.7-.7-.7-1-.7-1.7ZM157.9,79.3h-4v-14h4v14Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.5,79.7c-2,0-3.6-.7-4.6-2.1v1.7h-4v-19.6h4v7.4c1.1-1.4,2.6-2.1,4.6-2.1s3.5.7,4.7,2.1c1.3,1.4,1.9,3.1,1.9,5.2s-.6,3.9-1.9,5.3c-1.2,1.4-2.8,2.1-4.7,2.1ZM169.4,76.2c1.1,0,2-.4,2.7-1.1.7-.8,1.1-1.7,1.1-2.8s-.4-2-1.1-2.8c-.7-.7-1.6-1.1-2.7-1.1s-1.4.2-2,.6-1.1.9-1.4,1.5v3.6c.3.6.8,1.1,1.4,1.5s1.3.6,2,.6Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4,76.2c.3,0,.6,0,.8-.2v2.9c-.5.4-1.2.6-2.1.6-1.6,0-2.6-.6-3.2-1.8-1.2,1.3-2.8,1.9-4.8,1.9s-2.8-.4-3.7-1.3c-1-.9-1.4-2-1.4-3.4s.5-2.6,1.6-3.4c1.1-.8,2.4-1.2,3.9-1.2s2.9.3,4,.9v-.4c0-1.8-1.2-2.6-3.7-2.6s-2.9.4-4.2,1.2v-3.3c1.4-.7,3.2-1.1,5.2-1.1s3.6.5,4.8,1.5c1.2,1,1.9,2.3,1.9,4v4.7c0,.7.3,1.1,1,1.1ZM182.9,63.3c-.6,0-1-.2-1.5-.6-.4-.4-.6-.9-.6-1.5s.2-1,.6-1.4c.4-.4.9-.6,1.5-.6s1.1.2,1.5.6.6.9.6,1.5-.2,1.1-.6,1.5-.9.6-1.5.6ZM188.5,73.8c-.8-.5-1.8-.8-2.9-.8s-1.5.2-2,.5-.7.8-.7,1.3.2,1.1.7,1.4c.4.3,1.1.5,1.8.5,1.4,0,2.4-.5,3.2-1.4v-1.4ZM190.5,62.7c-.4.4-.9.6-1.5.6s-1.1-.2-1.5-.6c-.4-.4-.6-.9-.6-1.5s.2-1.1.6-1.5c.4-.4.9-.6,1.5-.6s1.1.2,1.5.6c.4.4.6.9.6,1.5s-.2,1.1-.6,1.5Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.9,79.3h-4v-14h4v2.4c.4-.7,1.1-1.4,2-1.9.9-.5,1.9-.8,2.9-.8s.4,0,.4,0v3.9c-.4,0-.8-.1-1.2-.1-.9,0-1.8.2-2.5.7-.8.5-1.3,1.1-1.6,1.7v8.2Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.5,79.7c-2.1,0-3.9-.7-5.4-2-1.5-1.4-2.2-3.2-2.2-5.4s.7-4,2.2-5.3c1.5-1.3,3.3-2,5.4-2s2.9.3,4.2.9v3.4c-1.2-.6-2.4-.8-3.6-.8s-2.3.4-3.1,1.1c-.8.7-1.2,1.6-1.2,2.8s.4,2.1,1.3,2.8c.8.7,1.9,1.1,3.1,1.1s2.7-.3,3.8-1v3.4c-1.3.7-2.8,1-4.4,1Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.3,70.4v8.9h-4v-19.6h4v7.4c1.3-1.4,2.8-2.1,4.7-2.1s2.9.5,3.8,1.5,1.3,2.4,1.3,4.3v8.6h-4v-7.8c0-1-.2-1.8-.7-2.2-.5-.5-1.1-.7-1.9-.7s-1.2.2-1.8.5-1.1.8-1.4,1.3Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.5,79.7c-2.2,0-4-.7-5.5-2-1.5-1.3-2.2-3.1-2.2-5.4s.7-3.8,2-5.2c1.3-1.4,3.1-2.1,5.3-2.1s3.6.7,4.9,2.2c1.2,1.4,1.8,3.2,1.8,5.2v1h-10c.2.9.7,1.7,1.6,2.2.8.5,1.9.8,3.1.8s3-.4,4.5-1.2v3.2c-1.3,1-3,1.4-5.3,1.4ZM243.6,70.8h6.1c0-.8-.3-1.5-.9-2-.5-.5-1.2-.8-2.1-.8s-1.6.3-2.2.8c-.6.5-.9,1.2-1,2Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.7,70.4v8.9h-4v-14h4v1.7c1.3-1.4,2.8-2,4.7-2s2.9.5,3.8,1.5,1.3,2.4,1.3,4.3v8.6h-4v-7.8c0-1-.2-1.8-.7-2.2-.5-.5-1.1-.7-1.9-.7s-1.2.2-1.8.5-1.1.8-1.4,1.3Z",
    style: {
      fill: "#b40055"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M77.5,19.3h-3.6l7.2-16.8h3.3l7.2,16.8h-3.7l-1.6-3.9h-7.1l-1.6,3.9ZM82.7,6.7l-2.5,5.8h4.9l-2.4-5.8Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.9,19.6c-1.7,0-3-.6-3.9-1.8v1.5h-3.4V2.5h3.4v6.3c.9-1.2,2.2-1.8,3.9-1.8s3,.6,4,1.8c1.1,1.2,1.6,2.7,1.6,4.4s-.5,3.3-1.6,4.5c-1.1,1.2-2.4,1.8-4,1.8ZM99.9,16.6c1,0,1.7-.3,2.3-1,.6-.7.9-1.4.9-2.4s-.3-1.7-.9-2.4c-.6-.6-1.4-1-2.3-1s-1.2.2-1.7.5-.9.8-1.2,1.3v3.1c.3.5.7,1,1.2,1.3s1.1.5,1.7.5Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.8,19.3h-3.4V6.2l-3.5,1.8v-3.4l3.9-2.1h3v16.7Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.2,19.3h-3.4V6.2l-3.5,1.8v-3.4l3.9-2.1h3v16.7Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.5,19.3h-3.4V6.2l-3.5,1.8v-3.4l3.9-2.1h3v16.7Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.9,19.6c-2.5,0-4.6-.6-6.4-1.8v-3.6c.7.6,1.6,1.1,2.8,1.6,1.2.4,2.3.6,3.4.6s1.7-.2,2.3-.5c.6-.3.9-.8.9-1.4s-.3-1.1-.9-1.4c-.2-.1-.6-.3-1-.4l-.6-.2-1.3-.4-1.2-.4c-.2,0-.6-.2-1.1-.4-.5-.2-.9-.4-1.1-.5-.8-.6-1.4-1.1-1.6-1.5-.4-.8-.6-1.5-.6-2.3,0-1.5.6-2.6,1.7-3.5,1.1-.9,2.7-1.3,4.6-1.3s3.8.5,5.5,1.4v3.3c-1.7-1.1-3.5-1.6-5.4-1.6s-2.8.6-2.8,1.6.3.9.9,1.1c.4.2.8.4,1.4.5.7.2,1.4.4,1.8.5,1.4.4,2.6,1,3.6,1.7,1.1.8,1.7,1.9,1.7,3.5s-.6,2.9-1.9,3.8c-1.3.9-2.8,1.4-4.8,1.4Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.1,15.6v-5.4h-2.3v-2.8h2.3v-3.3h3.4v3.3h3.4v2.8h-3.4v4.7c0,.6.1,1,.4,1.3.3.3.7.4,1.2.4s1.2-.1,1.7-.4v2.8c-.7.4-1.6.6-2.8.6-2.6,0-3.9-1.3-3.9-4Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.3,4.2c0-.6.2-1.1.6-1.4.4-.4.9-.6,1.4-.6s1,.2,1.4.6c.4.4.6.9.6,1.4s-.2,1-.6,1.4-.9.6-1.4.6-1-.2-1.4-.6-.6-.9-.6-1.4ZM178,19.3h-3.4V7.3h3.4v11.9Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.9,19.3h-3.4V7.3h3.4v1.5c.9-1.2,2.1-1.8,3.6-1.8s1.6.2,2.3.6c.7.4,1.1.9,1.4,1.5.4-.6,1-1.1,1.7-1.5.7-.4,1.5-.6,2.4-.6,1.3,0,2.3.4,3.1,1.2s1.1,2,1.1,3.5v7.5h-3.4v-6.7c0-1.6-.7-2.5-2-2.5s-1,.2-1.5.5-.8.7-1,1.2v7.5h-3.4v-6.7c0-1.6-.7-2.5-2-2.5s-1,.2-1.4.5c-.5.3-.8.7-1.1,1.1v7.6Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,19.3h-3.4V7.3h3.4v1.5c.9-1.2,2.1-1.8,3.6-1.8s1.6.2,2.3.6c.7.4,1.1.9,1.4,1.5.4-.6,1-1.1,1.7-1.5.7-.4,1.5-.6,2.4-.6,1.3,0,2.3.4,3.1,1.2s1.1,2,1.1,3.5v7.5h-3.4v-6.7c0-1.6-.7-2.5-2-2.5s-1,.2-1.5.5-.8.7-1,1.2v7.5h-3.4v-6.7c0-1.6-.7-2.5-2-2.5s-1,.2-1.4.5c-.5.3-.8.7-1.1,1.1v7.6Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.6,19.6c-1.9,0-3.4-.6-4.7-1.7-1.3-1.1-1.9-2.7-1.9-4.6s.6-3.3,1.7-4.4c1.1-1.2,2.6-1.8,4.5-1.8s3.1.6,4.1,1.8c1,1.2,1.6,2.7,1.6,4.5v.9h-8.6c.2.8.6,1.4,1.3,1.8.7.4,1.6.6,2.7.6s2.6-.4,3.8-1.1v2.7c-1.1.8-2.6,1.2-4.5,1.2ZM228.3,12.1h5.2c0-.7-.3-1.3-.7-1.7-.5-.5-1-.7-1.8-.7s-1.4.2-1.9.7c-.5.4-.8,1-.9,1.7Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.8,11.7v7.6h-3.4V7.3h3.4v1.4c1.1-1.2,2.4-1.7,4-1.7s2.4.4,3.2,1.3,1.1,2.1,1.1,3.6v7.3h-3.4v-6.6c0-.9-.2-1.5-.6-1.9-.4-.4-1-.6-1.6-.6s-1,.1-1.5.4-.9.7-1.2,1.1Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.7,11.6c-.6,0-1.1-.2-1.5-.6s-.6-.9-.6-1.5.2-1.1.6-1.5.9-.6,1.5-.6,1.1.2,1.5.6c.4.4.6.9.6,1.5s-.2,1.1-.6,1.5c-.4.4-.9.6-1.5.6ZM255.7,19.5c-.6,0-1.1-.2-1.5-.6-.4-.4-.6-.9-.6-1.5s.2-1.1.6-1.5.9-.6,1.5-.6,1.1.2,1.5.6c.4.4.6.9.6,1.5s-.2,1.1-.6,1.5-.9.6-1.5.6Z",
    style: {
      fill: "#b40055"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M208.7,242.7h0v-11.3c-.1-.5-.1-.9,0-1.4v-7c-1.4.3-2.7,1.2-3.5,2.4-1.1,1.6-1.1,3.6-.2,5.4l2.4,4.7c.2.5.4,1,.4,1.4,0,1.8-.7,3.5-1.9,4.8l-1.6,1.7c-.6.6-1.1,1.3-1.5,2.1h2.7c1.8,0,3.3-1.3,3.3-2.8Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.8,127.1c.3,0,.7.2,1,.2,1.3,0,2.6-.8,3-2.2l6.4-19.1c.6-1.7-.3-3.5-2-4-1.7-.5-3.5.3-4,2l-6.4,19.1c-.6,1.7.3,3.5,2,4Z",
    style: {
      fill: "#55c3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.3,139.4c.6.4,1.2.6,1.9.6,1,0,1.9-.4,2.5-1.3l9.6-12.7c1-1.4.8-3.4-.6-4.4-1.4-1-3.4-.8-4.4.6l-9.6,12.7c-1,1.4-.8,3.4.6,4.4Z",
    style: {
      fill: "#fac328"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M241.3,250c0-4.6-1.4-6.9-3.7-9.4l-1.6-1.7c-.3-.3-.6-.8-.7-1.5l2.2-4.4c1.6-3.1,1.4-6.7-.4-9.7-1.9-3-5.1-4.7-8.6-4.7s-4.5.5-6.6,1.4l-2,.8c-.3.1-.4.2-.6.3,0,0,0,0,0,0h-.1c0,0,0-.1,0-.1h0s0,0,0,0h0s-2.1-1-2.1-1c-.5-.2-1-.4-1.4-.5-1.7-.6-3.6-.9-5.4-.9s-.9,0-1.4.1c-2.9.4-5.5,2.1-7.1,4.5-1.9,2.9-2.1,6.6-.5,9.8l2.3,4.4c0,.7-.4,1.2-.7,1.5l-1.6,1.7c-1.3,1.4-2.3,3-2.9,4.8-.5,1.5-.8,3.1-.8,4.6v.2c0,.6,0,1.3.2,2,.3,1.9,1.1,3.7,2.2,5.3-1.5,2-2.3,4.4-2.3,6.9v1.1c0,7.4,7.4,13.4,13.5,13.4h.1c4.3,0,7.1-1.4,8.3-2.1,1.2.7,3.9,2.1,8.4,2.1,6.1,0,13.5-6,13.5-13.4v-1c0-2.5-.8-4.9-2.2-6.8,1.1-1.3,2.5-3.6,2.5-7.6ZM233.6,255.2c-.1,0-.3,0-.4,0-2,0-7-.7-7.1-4.1,0-1,.4-2.2,1.1-2.7.4-.3.9-.4,1.4-.4s.9.1,1.3.3c.3.2.7.2,1,.2.8,0,1.5-.4,1.9-1.2.3-.5.3-1.1.2-1.6-.2-.6-.5-1-1.1-1.3-1-.6-2.2-.9-3.3-.9s-2.4.3-3.5.9c-2.1,1.2-3.4,3.4-3.4,5.9,0,2.4.7,4.4,2.2,5.9,2.8,2.8,7.3,3.2,9.2,3.2,0,0,.2.2.2.2,1.5,1.2,2.3,2.8,2.3,4.7v1c0,4.4-3.6,8-8,8h-.3c-.9,0-1.8-.1-2.8-.4-.8-1-1.2-2.2-1.2-3.4h0c0-2.8,0-3.6,1.8-4.3h0s0,0,0,0c1.1-.5,1.7-1.8,1.3-2.9-.3-.9-1.2-1.4-2.1-1.4s-.5,0-.7.1c-3,1.1-4.1,3.2-4.5,5.4-.4-2.3-1.5-4.3-4.5-5.4-.2,0-.5-.1-.7-.1-.9,0-1.7.6-2.1,1.4-.4,1.1.2,2.4,1.3,2.9h0s0,0,0,0c1.7.6,1.8,1.5,1.8,4.2h0c0,1.3-.4,2.6-1.3,3.5-.8.2-1.7.3-2.6.3h-.3c-4.4,0-8-3.6-8-8v-1.1c0-1.8.8-3.5,2.2-4.6,0,0,.1-.1.2-.2.1,0,.3,0,.4,0,1.9,0,6.5-.3,9.3-3.2,1.5-1.5,2.2-3.5,2.2-5.9,0-1.8-.7-3.5-2-4.8-.4-.4-.9-.8-1.5-1.1-1.1-.6-2.3-.9-3.5-.9s-2.3.3-3.3.9c-.5.3-.9.7-1,1.2-.2.6-.1,1.2.1,1.7.4.7,1.1,1.2,1.9,1.2s.7,0,1-.2c.4-.2.9-.3,1.3-.3.5,0,1,.1,1.4.4.2.1.4.4.6.7.3.6.5,1.3.5,2,0,3.4-5.1,4.1-7.1,4.1s-.4,0-.6,0c-1-1-1.6-2.2-2-3.5-.1-.5-.2-1.1-.2-1.6v-.2c0-1.4.3-2.6.9-3.8.4-.7.8-1.3,1.3-1.9l1.6-1.7c1.4-1.5,2.2-3.5,2.2-5.5s-.2-1.3-.5-1.9l-2.4-4.7c-.7-1.4-.7-3.1.2-4.4.7-1,1.7-1.7,2.9-2,.4,0,.7-.1,1.1-.1,1.6,0,3.1.3,4.6,1h.1s2,.9,2,.9h.1c.7.4,1.4.7,2.5.7s1.6-.3,2.2-.5c.1,0,.3-.1.4-.2l2.1-.8h0s0,0,0,0c1.5-.6,3-1,4.6-1s3.1.8,3.9,2.1c.8,1.3.9,3,.2,4.4l-2.4,4.7c-.3.5-.5,1.2-.5,1.9,0,2,.8,3.9,2.2,5.5l1.6,1.7c1.3,1.4,2.1,3.3,2.2,5.2v.4s0,.2,0,.2c0,2-.8,3.7-2.3,5Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.9,236.8c-.2,0-.3,0-.5,0-.6.3-1.3.5-2,.6v-2.7c.8-.2,1.4-.6,1.4-1.2,0-.7-1.2-1.3-2.6-1.3s-2.6.6-2.6,1.3.6,1,1.5,1.2v2.5c-.6-.1-1.2-.3-1.8-.6-.2,0-.3-.1-.5-.1-.3,0-.5,0-.7.2-.2.1-.3.3-.4.4-.3.5,0,1.1.4,1.4,0,0,.1,0,.2.1,1.3.6,2.7.9,4,.9s2.7-.3,4-.9c.6-.2.9-.9.6-1.5-.2-.4-.6-.7-1.1-.7Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.1,227.5c-.9,0-1.7.3-2.3.9-.5.5-.5,1.2,0,1.6.2.2.5.3.8.3s.6-.1.8-.3c.2-.2.4-.3.6-.3s.4,0,.6.3c.2.2.2.4.2.6s-.1.5-.2.6c-.5.5-.5,1.2,0,1.6.2.2.5.3.8.3s.6-.1.8-.3h0c.6-.6.9-1.4.9-2.3s-.3-1.7-.9-2.3c-.6-.6-1.4-.9-2.3-.9Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.8,230.1c.5-.5.5-1.2,0-1.6-.6-.7-1.4-1-2.3-1-.8,0-1.6.3-2.2.9-.4.4-.7,1-.8,1.5v1.4c.1.6.4,1.1.8,1.6.2.2.5.3.8.3s.6-.1.8-.3c.5-.5.5-1.2,0-1.6-.4-.3-.4-.9,0-1.2.2-.2.4-.3.6-.3s.4,0,.6.3c.2.2.5.3.8.3s.6-.1.8-.3h0Z",
    style: {
      fill: "#b40055"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 141.7,
    width: 33.3,
    height: 6.6,
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,141.7c-4.3,0-7.8,3.5-7.8,7.8v93.3c0,5.1,4.2,9.2,9.3,9.2h69.7v-6.6h-69.2c-1.7,0-3-1.3-3-3v-91.1c0-1.6,1.3-3,3-3h12.6v-6.6h-14.5Z",
    style: {
      fill: "#b40055"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.5,141.7h-14.5v6.6h12.6c1.6,0,3,1.3,3,3v62.7h6.7v-64.5c0-4.3-3.5-7.8-7.8-7.8Z",
    style: {
      fill: "#b40055"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.2,166.6h0c-1.9,0-3.5-1.6-3.5-3.5v-42.2c0-10.3-8-19.1-18.2-19.4-10.8-.4-19.6,8.3-19.6,18.9v42.7c0,1.9-1.6,3.5-3.5,3.5h0c-1.9,0-3.5-1.6-3.5-3.5v-42.1c0-14.2,11.1-26.1,25.2-26.5,14.7-.4,26.7,11.4,26.7,26v42.7c0,1.9-1.6,3.5-3.5,3.5Z",
    style: {
      fill: "#b41257"
    }
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCrowdvotingFoerdersummenVisualisierungInlineXsRgb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/crowdvoting-foerdersummen-visualisierung-inline-xs-rgb.224770c571e902084ceba239b02ff2dd.svg";